import { render } from "./OverviewSettings.vue?vue&type=template&id=35db190f&ts=true"
import script from "./OverviewSettings.vue?vue&type=script&lang=ts"
export * from "./OverviewSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__